
import { Component, Vue, Prop } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
import { generateMetaInfo, getServiceJsonLd, getFaqJsonLd, injectJsonLd } from "@/utils/seo";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class GrowthCamp extends Vue {
  get metaInfo() {
    return generateMetaInfo({
      title: "大增长营 | BLM科学经营方法论+工作法，可复制的结构性增长 - 光华赋能",
      description:
        "光华赋能大增长营，以BLM科学经营为核心，结合方法论+工作法，帮助企业实现可复制的结构性增长。面向企业创始人与核心高管，通过系统学习与实战演练，破解增长瓶颈。",
      keywords:
        "大增长营,BLM科学经营,企业增长,结构性增长,方法论,工作法,企业培训,光华赋能",
      path: "/growth-camp",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "BLM科学经营" },
        { name: "大增长营" }
      ],
      jsonLd: getServiceJsonLd({
        name: "大增长营",
        description:
          "以BLM科学经营为核心，结合方法论+工作法，帮助企业实现可复制的结构性增长的高管培训项目。",
        category: "BLM科学经营培训"
      })
    });
  }
  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/e3e99f9a7a7fc03a657a479094712517.png";
  pic2 = "/img/8472cc555a16f46c5de2ceb8ee75d95c.png";
  pic3 = "/img/ab5f4d38299d660cf14ed2d2feb53fef.png";
  pic4 = "/img/2569e567ce58f92eb7c4cec27dcbfa2e.png";
  pic5 = "/img/647603baf18fbf956bad19ee024e61c4.png";
  pic6 = "/img/4bb0682da91d6941ee603a99f6da466f.png";
  pic7 = "/img/4bc88a3854a39e14ef05613d2eec2664.png";
  pic8 = "/img/6fb6447de6eeedf004b5ce7255e3b97b.png";
  pic9 = "/img/74e63a5beb6253144fa6aa087b4e82b5.png";

  result1 = "/gh_website/result1.png";
  companyArr: any = [];
  List = [
    { title: "BLM科学经营", url: "" },
    { title: "大增长营", url: "" }
  ];

  resultArr = [] as any;
  created() {
    this.initData();
  }
  initData() {
    this.resultArr = [];
    for (let index = 1; index < 9; index++) {
      this.resultArr.push("/gh_website/result" + index + ".png");
    }

    let companyArr0 = [];
    let companyArr1 = [];
    console.log(123456);
    for (let index = 1; index < 13; index++) {
      companyArr0.push("/gh_website/big-grow-activity" + index + ".png");
    }
    for (let index = 13; index < 25; index++) {
      companyArr1.push("/gh_website/big-grow-activity" + index + ".png");
    }

    console.log("companyArr0", companyArr0);
    console.log("companyArr1", companyArr1);
    this.companyArr.push(companyArr0);
    this.companyArr.push(companyArr1);
    console.log("companyArr", this.companyArr);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute("content", "BLM科学经营，大增长营，科研院");
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "以「科学经营」系统理论为底座，围绕企业高质量发展的核心，基于企业战略规划而设计学习方案，以终为始，有效学习，集中力量，高效学习，统一团队科学经营主线，助力企业力出一孔；BSC，BSC平衡积分卡，分拆对，业务视角、领导力，价值观，分目标，拆动作，对能力，差距分析，战略意图，市场洞察，创新焦点，业务设计，关键任务，正式组织，人才，市场结果，财务，客户，内部流程，学习与成长"
    );
    document.head.appendChild(metaTag2);
    // 注入 FAQPage JSON-LD
    injectJsonLd(
      "jsonld-faq",
      getFaqJsonLd([
        {
          question: "大增长营是什么样的课程？适合谁参加？",
          answer: "《BLM科学经营：大增长营》是光华赋能最王牌的沉浸式训战营产品，定位为「企业老板的增长必修课」。课程时长2天1夜，以BLM业务领先模型为内核，传授「分拆对」科学工作法，帮助企业找到增长引擎，实现业绩翻一倍。采用「学练考评赛奖」六步闭环教学模式，学员现场产出BSC大表、行动方案表等可落地工具。适合人群：企业创始人、董事长、CEO等一号位；总裁、总经理、营销负责人；核心高管团队（建议老板带高管一起学）；面临增长瓶颈、想找到第二增长曲线的企业决策者。课程面向决策层，建议10人以上企业参加效果更好。"
        },
        {
          question: "大增长营的核心内容和BLM增长飞轮是什么？",
          answer: "大增长营核心内容包含四大训战模块：第一模块「升级战略性思维」，核心理念包括战略性思维、大思维、敢做第一、战略聚焦、大增长思维、DOUBLE翻一倍、品类创新；第二模块「科学经营12349一致性模型」，涵盖经营与管理、3B（Business/BLM/BSC）、横向三件事纵向五件事；第三模块「业务解码与执行落地」，核心是MBO、平衡积分卡BSC、分拆对（分目标、拆动作、对能力），学员现场产出BSC大表等落地工具；第四模块「全域运营与打造核心产品」，涵盖运营思维、未来业务组合、根据地业务战略、价值主张。BLM增长飞轮六步循环：明确使命愿景目标→SP/BP复盘差距分析→确定关键任务BP打仗落地→明确价值主张优化业务价值曲线→创新业务增长路径→市场洞察找出破局点，循环驱动实现「老板一心不乱、高管同频共振、组织力出一孔」。"
        },
        {
          question: "大增长营2天1夜具体学什么？能带走什么？",
          answer: "大增长营采用「训前预备—集中训战—训后实战」三段式设计。训前需完成自检测评和学习资料预习。集中训战2天1夜采用「学练考评赛奖」六步闭环：学——方永飞老师亲授BLM科学经营理念、结构知识、实战案例、方法工具；练——小组研讨+作业练习+模拟演练，学员以自己企业为案例现场梳理BSC大表等工具；考——课后在线考试巩固；评——导师/专家团现场深度辅导与点评，专家一对一辅导工具表单实操；赛——课堂练习方案成果PK，学员现场立军令状承诺增长目标；奖——带回一套企业可落地的工具/手册/参考案例模板。学员现场可带走：1张业务增长要素分布大图、20+训战工具包（BSC大表、行动方案表、绩效合约表、必须打赢的仗等）、企业诊断透视镜和方法论、企业增长路径图、公司/部门/员工年/季/月BSC大表。训后提供导师进一步建议、班主任一对一落地跟进、一年内复训（1000元/人/次）。"
        },
        {
          question: "大增长营的价格是多少？有什么优惠政策？",
          answer: "大增长营市场统一售价为19800元/人，光华提供多种优惠政策，实际报名价格远低于市场价。早鸟价政策是最主要的优惠方式：单人早鸟价3980元/人，适合老板个人先体验学习；双人早鸟价6980元/2人，适合老板与业务负责人一同参加，平均每人3490元，性价比更高；早鸟价根据情况逐期涨价，越早报名越优惠。其他优惠政策：渠道伙伴享有专属优惠政策；共创会会员享有专属优惠；光华老学员享有专属优惠，复训或推荐新学员均可享受相应政策；企业团队报名享有团报政策，多人组团参加可享受更优惠的团队价格。复训政策：大增长营支持一年内复训，复训费用为1000元/人/次。开课信息：大增长营每月一期，滚动开课，上课地点以浙江杭州为主，同时在全国巡回开课。以上价格来自光华赋能《产品手册2026》官方画册，实际价格以最新通知为准。"
        },
        {
          question: "大增长营和普通培训课有什么区别？",
          answer: "大增长营与普通培训课的区别主要体现在四个核心维度。第一，体系完整vs零散技巧：普通培训课往往是「钓鱼技巧」式的零散知识，课程之间缺乏体系关联；大增长营基于华为等世界顶级公司在用的BLM业务领先模型，传授的是一套完整的科学经营体系（BLM+分拆对），学员学完能自己诊断企业，持续找到增长点。第二，工具落地vs听完就忘：普通培训课多是「老师讲、学员听」的单向灌输，课上激动、课后不动；大增长营采用训战结合模式，课堂上学员亲手使用并带走全套实战工具包，包括BSC大表、行动方案表、目标绩效承诺书、必须打赢的仗等20+工具表单，拿回去填上自己企业的数据就能用。第三，导师顶尖vs通用讲师：大增长营由光华赋能董事长、「科学经营」理论和「分拆对工作法」创始人方永飞老师亲自领衔授课，方老师有23年企业经营研究经验，累计服务20000余家企业，著有17部著作。第四，生态优势vs单次交易：参加大增长营不仅是上一门课，更是进入光华高端企业家生态的入口，可链接共创会、EMBA同学圈、私董会、企业互访等高端圈层资源。"
        },
        {
          question: "参加大增长营后有什么后续支持？",
          answer: "大增长营为学员提供了完善的训后支持体系。第一，导师/专家团进一步建议：训战后，导师和专家团会根据学员在课堂上产出的方案和工具，提供进一步的优化建议和落地指导。第二，班主任一对一落地跟进：每位学员都有专属班主任进行一对一落地跟进，定期回访学员在企业落地过程中遇到的问题，提供针对性的指导和支持。第三，一年内复训政策：大增长营支持一年内复训，复训费用为1000元/人/次，学员可巩固学习成果或带新的高管团队再次学习统一认知，复训还能接触每期更新的案例和方法论迭代。第四，进入光华高端企业家生态：参加大增长营后，学员可进入光华高端企业家生态，链接共创会、EMBA同学圈、私董会、企业互访等资源，在社群中交流分享、共同提高。第五，后续资源对接服务：光华可为学员提供后续资源对接服务，包括咨询陪跑服务对接（如分拆对工作法落地辅导、增长陪跑、科学经营陪跑等）、数字化工具对接（GTT绩效飞轮、微学等）、企业内训定制等。第六，学员转训奖励机制：学员回企业后转训工具落地应用成果，或通过直播、语音、视频分享案例，可获得额外奖励。"
        }
      ])
    );
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
